export default "__VITE_ASSET__Byqa1UdC__"